class Accordion {
  constructor(elem) {
    this.accordion = elem;
    this.title = this.accordion.find('[data-accordion-title]');
    this.body = this.accordion.find('[data-accordion-body]');
    this.more = this.accordion.find('[data-accordion-more]');
    this.items = this.accordion.find('[data-accordion-item]');
  }

  initialize() {
    const that = this;

    this.more.on('click', function() {
      that.items.toggleClass('show');
      let text = $(this).text();

      $(this).text($(this).attr('data-accordion-more'));
      $(this).attr('data-accordion-more', text);
    });
  }
}

export {Accordion}

$(window).on('load', function() {
  let accordions = [];

  if ($('[data-accordion]').length > 0) {
    $('[data-accordion]').each(function(i) {
      accordions[i] = new Accordion($(this));
      accordions[i].initialize();
    });
  }
});
